import React, {FC} from 'react';
import {TextField} from "@mui/material";
import {observer} from "mobx-react";
import {useStorageUserConfigContext} from "@app/modules/UserConfig/contexts/storage";


type TProps = {
    // onChange(value: string)
}

export const UserLogin: FC<TProps> = observer((props: TProps) => {

    const {userConfigStore} = useStorageUserConfigContext()


    return <TextField type={"login"}
                      label={"Login"}
                      name={"user-login"}
                      autoComplete="off"
                      onChange={e => userConfigStore.userLogin = e.target.value}
                      value={userConfigStore.userLogin}
    />

})

